module.exports = __webpack_public_path__ + "img/sb4.2128d2b4.png";